import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { combineLatest, filter, map, take } from 'rxjs';
import { UserStore } from '../user/store/user.store';

export const TenantReadyGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);

  // Warten, bis checkRegistrations definitiv geantwortet hat (null = noch offen).
  // Sofort durch koennen: nicht-registrierte User UND registrierte ohne Mandanten-Zugang
  // (in keinen Mandanten eingeladen -> Willkommens-Dashboard). Registrierte mit Mandant
  // warten zusaetzlich auf den activeTenant.
  return combineLatest([
    toObservable(userStore.isRegisteredNectaOne),
    toObservable(userStore.activeTenant),
    toObservable(userStore.noTenantAccess),
  ]).pipe(
    filter(([registered, tenant, noTenantAccess]) =>
      registered === false || noTenantAccess || (registered === true && tenant !== null)),
    take(1),
    map(() => true),
  );
};
